import type { Conf } from 'src/global';
import changePendoText from 'src/support/change-pendo-text';
import { disableChat, enableChat, isSales, setPendoChatDisplay } from 'src/util';
import waitForDepartment from 'src/waitForDepartment';

export const loadPaid = (conf: Conf) => {
    const switchChat = (isOnline: boolean) => {
        if (isOnline) {
            isSales(conf) && setPendoChatDisplay('block');
            enableChat(conf);
        } else {
            isSales(conf) && setPendoChatDisplay('none');
            disableChat();
        }
        changePendoText(isOnline, conf);
    };

    waitForDepartment(switchChat, conf.waitCount, conf);
};

export default loadPaid;
